import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { SearchPackage, SearchRecord, SearchVendors, VendorResponseTypes } from '../models/searchPackage';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgForm, AbstractControl, FormControl } from '@angular/forms';
import { Subscription, Observable, Subject } from 'rxjs';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SearchAddDialogComponent } from '../components/search-add-dialog/search-add-dialog.component';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { Client } from 'src/app/clients-module/models/clientLocation';

@Component({
  selector: 'app-package-edit',
  templateUrl: './package-edit.component.html',
  styleUrls: ['./package-edit.component.less']
})
export class PackageEditComponent implements OnInit,OnDestroy {
  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {
    try {
      if(this.modalRef) this.modalRef.close();
    } catch (error) {
      
    }
  }
  
  @ViewChild('form',{}) ngForm: NgForm;
  public packageToEdit : SearchPackage;
  formChangesSubscription : Subscription;
  modalRef : NgbModalRef;
  public validationMessages : string[] = [];

  // Client Mode Fields
  clientId : number;
  clientMode : boolean = false;
  clientToUse : Client;

  constructor(public packages : SearchPackageService, 
    public auth : AuthService,
    public activatedRoute: ActivatedRoute,
    public toast : ToastrService,
    public location : Router,
    private modalService: NgbModal,
    private clients : ClientService) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      let id = p.get('pkg');
      let clnt = p.get('clnt');
      if(clnt) {
        this.clientId = parseInt(clnt);
        this.clientMode = true;
        this.clients.GetClientById(this.clientId).subscribe((scc:Client)=>{
          this.clientToUse = scc;
        })
      }
      
      this.packages.FetchSearchPackageById(id).subscribe((pkg: Array<SearchPackage>)=>{
        this.packageToEdit = Object.assign(new SearchPackage(),pkg[0]);
        this.packageToEdit.searches = this.packageToEdit.searches.map(s =>{
          return Object.assign(new SearchRecord(), s);
        });
        this.validatePackageContents(); 
      })
    })
  }

  searchAdded(event : SearchRecord){
    this.packages.AssociateSearchToPackage(event.id,this.packageToEdit.id).subscribe((evt: boolean)=>{
      if(evt){
        this.toast.success(`${event.name} was added to package successfully.`);
        this.packageToEdit.searches.push(event);
      }
      else{
        this.toast.error(`Error adding ${event.name} to package.`);
      }
      this.validatePackageContents();
    },(err: any)=>{
      this.toast.error(`Error adding ${event.name} to package.`);
    })
  }

  addSearch(){
    let srch = new SearchRecord();
    srch.includedInBundledPrice = true;
    this.modalRef = this.modalService.open(SearchAddDialogComponent, { centered: true, size: 'lg' })
    this.modalRef.componentInstance.name = 'SearchAddDialogComponent';
    let searchToAdd = srch;
    this.modalRef.componentInstance.searchAdded.subscribe((scc: SearchRecord) => this.searchAdded(scc));
    this.modalRef.componentInstance.search = searchToAdd;
    this.modalRef.componentInstance.canAddTieredSearch = this.packageToEdit.isTieredPackage;
    this.modalRef.componentInstance.existingPackage = this.packageToEdit;
    this.modalRef.componentInstance.packageEditMode = true;
  }

  savePackage(){
    if(!this.validatePackageContents()) {
      this.toast.error('Validation errors present. Please address the noted issues before using this package.','',{ closeButton: true, disableTimeOut: true });
      return; 
    }

    // then send the updates
    this.packages.UpdatePackage(this.packageToEdit).subscribe((scc: any)=>{
      if(scc)
        this.toast.success('Package updated Successfully');
      else
        this.toast.error('Errror Updating Search Package');
      this.location.navigateByUrl(`packages`);
    },(err: any)=>{
      this.toast.error('Errror Updating Search Package');

    })
  }

  //SCRSTP-1380: we need a method to validate the contents of a package (versus form level validation)
  validatePackageContents() : boolean {
    //first validation rule.. if there's a cleara eviction, it MUST BE run manually.
    if(this.packageToEdit.searches.find(s => s.vendor == SearchVendors.Cleara && s.searchType == VendorResponseTypes.Eviction) &&
      !this.packageToEdit.searches.find(s => s.vendor == SearchVendors.Cleara && s.searchType == VendorResponseTypes.Person)) {
        this.validationMessages.push("[CL] Eviction searches must be paired with [CL] SSN Traces.");
      return false;
    }
    else {
      this.validationMessages = [];
      return true;
    }
  }

}
